    <template>
    <div class="fileinfomodel">
        <el-dialog class="dialogBox" :title="tit" :visible.sync="fileVisible" width="55%" :before-close='beforeClose'  center>
            
               
            
            <el-form :model="form"  ref='form' class="flex ml20 mr20 c314" :rules="rules" >
                <el-row >
                <el-col :span='22' v-if="tit==$t('fileInfo.boundBoard')">
                    <el-form-item    :label="$t('manipulation.comBoard')" prop="gatewayName" :label-width="formLabelWidth1">
                            <el-input v-model="form.imei" @blur="blurinput" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item  :label="$t('fileInfo.boundType')" prop="gatewayType" :label-width="formLabelWidth1">
                            <el-select v-model="form.gatewayType"  :disabled="disabled" style="width:100%">
                                    <el-option
                                    v-for="(item,index) in typeList2"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.val">
                                    </el-option>
                                </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="tit!=$t('fileInfo.boundBoard')">
                    <el-col :span='11'>
                        <el-form-item :label="$t('manipulation.airNum')" prop='devNumber' :label-width="formLabelWidth">
                                <el-input v-model="form.devNumber"  v-on:input ="inputFunc" autofocus ref="dev"   :disabled="disabled"></el-input>
                            </el-form-item>
                    </el-col>
                     <el-col :span='11'>
                        <el-form-item  :label="$t('manipulation.airModel')" prop='devModel' :label-width="formLabelWidth">
                                <el-select v-model="form.devModel"   filterable   @blur="selectBlur1"
                  @change="selchange1" :disabled="disabled" style="width:100%">
                                    <el-option
                                    v-for="(item,index) in typeList"
                                    :key="index"
                                    :label="item.dictValue"
                                    :value="item.dictKey">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                    </el-col>
                    <el-col :span='11'>
                        <el-form-item :label="$t('fileInfo.devadress')" :label-width="formLabelWidth">
                                <el-input v-model="form.devCode" autocomplete="off" :disabled="tit===$t('roleManage.revise')"></el-input>
                            </el-form-item>
                    </el-col>
                    <el-col :span='11'>
                        <el-form-item :label="$t('realtimeinfo.roomNum')" prop='towerNumber' :label-width="formLabelWidth">
                                <el-input v-model="form.towerNumber" autocomplete="off" :disabled="disabled"></el-input>
                            </el-form-item>
                    </el-col>
                    <el-col :span='11'>
                        <el-form-item :label="$t('manipulation.comBoard')" :label-width="formLabelWidth">
                                <el-input v-model="form.imei" autocomplete="off" :disabled="tit===$t('roleManage.revise')"></el-input>
                            </el-form-item>
                    </el-col>
                    <el-col :span='11'>
                        <el-form-item  :label="$t('fileInfo.boundType')" :label-width="formLabelWidth">
                           
                                <el-input v-model="form.gatewayTypeName" autocomplete="off" :disabled="tit===$t('roleManage.revise')"></el-input>
                            </el-form-item>
                    </el-col>
                   
                    <el-col :span='11'>
                        <el-form-item  :label="$t('manipulation.elevatorBrand')" prop='elevatorBrand' :label-width="formLabelWidth">
                               
                                <el-select v-model="form.elevatorBrand" filterable   @blur="selectBlur"
                  @change="selchange" :disabled="disabled" style="width:100%">
                                    <el-option
                                    v-for="(item,index) in typeList1"
                                    :key="index"
                                    :label="item.dictValue"
                                    :value="item.dictKey">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                    </el-col>
                    <el-col :span='11'>
                        <el-form-item :label="$t('realtimeinfo.eleNum')" prop='stairsNumber' :label-width="formLabelWidth">
                                <el-input v-model="form.stairsNumber" autocomplete="off" :disabled="disabled"></el-input>
                            </el-form-item>
                    </el-col>
                </el-col>
                
                </el-row>
            </el-form>
            
            <div slot="footer" class="dialog-footer flex row vertical-center" v-if="!disabled">
                <el-button @click="closedialog" size="small" class="mr40">{{$t('manipulation.cancel')}}</el-button>
                <el-button type="primary" size="small" @click="handleSubmit">{{$t('manipulation.sure')}}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import {dictList,putdevice,bindingImei,getDeviceModel} from '@/api/deviceOverview/file';
export default {
    name: 'fileinfomodel',
    props: {
        fileVisible: {
            type: Boolean,
            default: false
        },
        tit: {
            type: String,
          
        },
        
    },
    data() {
        return {
            rules: {
                devNumber:[
                   { required: true, message:this.$t('fileInfo.pleInputAirCode'), trigger: 'blur' }
                ],
                towerNumber:[
                   { required: true, message: this.$t('fileInfo.pleInputAirlh'), trigger: 'blur' }
                ],
                stairsNumber:[
                   { required: true, message: this.$t('fileInfo.pleInputAirth'), trigger: 'blur' }
                ],
                devModel:[
                   { required: true, message: this.$t('fileInfo.pleInputAirxh'), trigger: 'blur' }
                ],
                elevatorBrand:[
                   { required: true, message: this.$t('fileInfo.pleInputAirpp'), trigger: 'blur' }
                ],
            },
            form:{
              elevatorBrand:null,
              devModel:null
            },
            pointChoseType: 'chose',
            formLabelWidth:'190px',
            formLabelWidth1:'190px',
            keyWordObj: null,         // 关键词检索变量
            map: null, 
             disabled: false,
             mapsearch:'',
             disabledLocation:'',
             typeList1:[],
             typeList2:[
                 {label:'4G',val:'4G'},
                 {label:'WIFI',val:'WIFI'},
             ],
             typeList:[],
             wayinfo1:'',
             testarr:[
                 
             ],
             timer:null,
            

        };
    },
    created() {
       
    },
    mounted() {
        this.$nextTick(() => {
            // this.$refs.dev.focus()
            })
        this.getdictList()
    },
    methods: {
        getblur(){
            this.$nextTick(function() {
                if (this.timer) {
                    clearTimeout(this.timer);
                }
                this.timer = setTimeout(() => {
                    this.$refs.dev.focus();
                }, 100);
            })
        },
       
        getDeviceModel(val){
            getDeviceModel({devNumber:val}).then(res=>{
              
                if(res.data.code==200){
                     let a = this.typeList.filter(v=>v.dictValue === res.data.data.dictValue)
                     if(a.length>0){
                         this.$set(this.form,'devModel',res.data.data.dictKey)
                     }
                }
            })
        },
        inputFunc(val){
           
            if(val.length>11){
                this.getDeviceModel(val)
            }
        },
        blurinput(){
            if(this.form.imei.length>14){
                this.$set(this.form,'gatewayType','4G')
            }else if(this.form.imei.length<13){
                this.$set(this.form,'gatewayType','WIFI')
            }
        },
        selectBlur1(e){
           this.form.devModel = e.target.value
           this.form.devModelName = e.target.value
           this.$forceUpdate();
        },
        selchange1(e){
             let a = this.typeList.filter(v=>v.dictKey === e)
             this.form.devModelName=a[0].dictValue
             this.form.devModel = e
        },
        selectBlur(e){
           this.form.elevatorBrand = e.target.value
            this.form.elevatorBrandName = e.target.value
           this.$forceUpdate();
        },
        selchange(e){
            let a = this.typeList1.filter(v=>v.dictKey === e)
             this.form.elevatorBrandName=a[0].dictValue
             this.form.elevatorBrand = e
        },
        getdictList(){
            dictList({code:"device_model"}).then(res=>{
                if(res.data.code===200){
                    this.typeList = res.data.data[0].children
                }
            })
            // 电梯
            dictList({code:"elevator_brand"}).then(res=>{
                if(res.data.code===200){
                    this.typeList1 = res.data.data[0].children
                }
            })
        },
        getinfo(info,way){
            this.form = JSON.parse(JSON.stringify(info))
           
            setTimeout(()=>{
                    console.log(this.$refs.dev)
                    // this.$refs.dev.focus()
            },100)
        },
        getinfo1(info){
            
            this.wayinfo1 = JSON.parse(JSON.stringify(info))
        },
        closedialog(){
            this.$emit('closefileinfo');
             this.init()
        },
       
        mapKeyWord(){

        },
        init() {
            this.form = {}
        },
        
        // 分页导航
        handleCurrentChange(val) {
            this.param.current = val;
            
        },
        // 提交表单
        handleSubmit() {
            // debugger
            if(this.tit!=this.$t('fileInfo.boundBoard')){
                // if(this.form.projectId){
                //     delete this.form.projectId
                // }
                
                putdevice(this.form).then(res=>{
                    if(res.data.code===200){
                        this.$message.success('操作成功')
                        this.getdictList()
                          this.$emit('closefileinfo','0');
                        this.init()
                    }
                })
            }else{
                this.form.projectId = this.wayinfo1.id
                
                bindingImei(this.form).then(res=>{
                     if(res.data.code===200){
                        this.$emit('closefileinfo','0');
                        this.init()
                    }
                })
            }
            
          
        },
        beforeClose(done) {
            this.init()
            this.$emit('closefileinfo');
          
        },
       
            
    }
};
</script>

<style lang="scss" scoped>
.fileinfomodel {
   
}

</style>
